<template>
    <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <form  @submit.prevent="save">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{translate('hsmIdentify.identifyHsm')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" :disabled="loading" :aria-label="translate('close')" @click="$emit('close')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{translate('hsmIdentify.hsmType')}}</label>
                                    <select v-model="DriverName" class="form-control" @change="providerChanged">
                                        <option value="akis">AKIS</option>
                                        <option value="ncipher">NCIPHER</option>
                                        <option value="safenet">SAFENET</option>
                                        <option value="safesign">SAFESIGN</option>
                                        <option value="aladdin">ALADDIN</option>
                                    </select>
                                </div>
                                <div v-if="DriverName">
                                    <div v-for="(s,counter) in HsmCertificates" :key="counter">
                                        <div class="form-check custom-radio-container">
                                            <input class="form-check-input custom-radio" type="radio" name="flexRadioDefault" :id=counter :value=s v-model="visualData" required/>
                                            <label class="form-check-label" :for=counter>
                                                <div class="select-label">
                                                    <h5> <b> {{s.signerName}} </b></h5>
                                                    <span>{{translate('hsmIdentify.serial')}}: {{s.certSerial}} </span>
                                                    <span>{{translate('hsmIdentify.issuerName')}}: {{s.issuerName}} </span>
                                                    <span>{{translate('hsmIdentify.certStart')}}: {{s.certNotBefore}} </span>
                                                    <span>{{translate('hsmIdentify.certEnd')}}: {{s.certNotAfter}} </span>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{translate('incomingDoc.password')}}</label>
                                    <input type="password" v-model="password" class="form-control" required>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-secondary" :disabled="loading" @click="$emit('close')">{{translate('close')}}</button>
                        <div>
                            <button type="button" class="btn btn-outline-secondary" :disabled="loading" @click="testHSM">{{translate('test')}}</button>
                            <button type="submit" v-if="!isCompleted" class="btn btn-success ml-2" style="width:100px;">{{translate('save')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import formMixin from '../formMixin.js';
import axios from 'axios'

export default {
    mixins: [formMixin],
    props:{
        hsmAccountId: { type: String}
    },
    components: {
    },
    created(){
        
    },
    data() {
        return {
            isCompleted: false,
            loading: false,
            modelName: 'RemPassword',
            errorMessage: null,
            data: {},
            DriverName: "",
            password: null,
            visualData: {},
            HsmCertificates: {}
        }
    },
    methods: {
        save(){
            this.loading = true;
            this.errorMessage = null;
            var postData = {}
            postData.driverName = this.DriverName 
            postData.slotNumber = this.visualData.slotNumber
            postData.certSerial = this.visualData.certSerial
            postData.password = this.password
            console.log(postData)
            return axios
              .post(`/RemPassword/setHsmPassword/${this.hsmAccountId}`, postData)
              .then(x => {
                alert(this.translate('messages.hsmSaveSuccess'))
                  this.isCompleted = true;
                  this.loading = false;
                  this.$emit('save', x);
                  
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.loading = false;
              });
        },
        providerChanged(){
            console.log("provider changed. this will be posted: ", this.DriverName)
            this.loading = true;
            this.errorMessage = null;
            return axios.get(`/RemPassword/gethsmcertificates`, {params :{driverName: this.DriverName}}).then(x => {
                this.HsmCertificates = x.data
                this.loading = false;
            }).catch( x => {
                alert(this.translate('errors.hsmCantShow'));
                console.log("GetHsmCertificates error:",x);
                this.loading = false
            });
        },
        testHSM(){
            var postData = {}
            postData.driverName = this.DriverName 
            postData.slotNumber = this.visualData.slotNumber
            postData.certSerial = this.visualData.certSerial
            postData.password = this.password
            console.log("test pressed. this will be posted: ", postData)
            this.loading = true;
            this.errorMessage = null;
            return axios.post(`/RemPassword/testHsmPassword/`, postData).then(() => {
                alert(this.translate('messages.success2'))
                this.loading = false;
            }).catch(x => {
                   window.processErrorResponse(x, this);
                   this.loading = false;
              });
        }
    }
}
</script>

<style scoped>
.custom-radio-container{
    border: 1px solid transparent;
    padding: 20px 30px;
    margin: 10px 2px;
    transition: 0.2s ease-in-out;
    border-radius: 4px;
}
.custom-radio-container:hover{
    background-color: rgb(230, 230, 230);
    border: 1px solid rgb(230, 230, 230);
    cursor: pointer;
}
    .select-label{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        cursor: pointer;
    }
</style>